module.exports = __webpack_public_path__ + "static/img/hero.ffec4320.jpeg";